import { drawArea } from "./drawArea";
import { drawRectangle } from "./drawRectangle";
import { drawSection } from "./drawSection";
import { drawTable } from "./drawTable";
import { drawText } from "./drawText";

export const drawObjects = (
  context,
  objects,
  canvasOffset,
  zoom,
  circleRadius,
  circlePadding,
  edgePadding,
  selectedCircles,
  selectedTableCircles,
  selectedArea,
  HoldTypes,
  seatingTickets,
  eventID
) => {
  // First draw all non-text objects
  objects
    .filter((obj) => obj.type !== "text")
    .forEach((obj) => {
      context.fillStyle = obj.color;

      if (obj.type === "rectangle") {
        drawRectangle(context, obj, canvasOffset, zoom);
      } else if (obj.type === "generalArea") {
        drawArea(context, obj, canvasOffset, zoom, selectedArea, seatingTickets);
      } else if (obj.type === "matrix") {
        drawSection(
          context,
          obj,
          canvasOffset,
          zoom,
          selectedCircles,
          HoldTypes,
          seatingTickets,
          eventID
        );
      } else if (obj.type === "table") {
        drawTable(
          context,
          obj,
          canvasOffset,
          zoom,
          circleRadius,
          circlePadding,
          edgePadding,
          selectedTableCircles,
          HoldTypes,
          seatingTickets
        );
      }
    });

  // Then draw text objects on top
  objects
    .filter((obj) => obj.type === "text")
    .forEach((obj) => {
      context.fillStyle = obj.color;
      drawText(context, obj, canvasOffset, zoom);
    });
};
